import {DoorType} from "./door";
import {ProductLinkType} from "../../generated/graphql";

export interface CustomerColors {
  primary?: string;
  primaryRgb?: string;
  primaryText?: string
  uploadPanel: {
    background?: string;
    color?: string;
  }

  imageButtons: {
    background?: string;
    color?: string;
  }
  imageButtonsBackground?: string
  imageButtonsText?: string
}

export interface Customer {
  name: string,
  homepageUrl?: string,
  config: CustomerConfig
}


export enum LogoPlacement {
  Left = 'LEFT',
  Center = 'CENTER',
  Right = 'RIGHT',
}

export enum ImageButtonsArrangement {
  Stacked = 'STACKED',
  Line = 'LINE',
}

export enum ImageButtonsPlacement {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export interface CustomerConfig {
  logoUrl: string;
  defaultLanguage: string;
  translationFileUrl: string;

  isBrandingEnabled: boolean;
  isFavoriteFeatureEnabled: boolean;
  allowMultipleDoors?: boolean;
  allowClippedCorners?: boolean;
  shopLinkOverwrite?: string

  enableDoorTypeDropdownSelection?: boolean

  gtmTag?: string;

  enabledExampleImageSets?: boolean;

  productLinkType: ProductLinkType;
  enabledProducts?: boolean;

  enabledShadowProfiles: boolean;
  drawGlassLayerInVisualisation: boolean;

  showRefineLayoutAfterUpload: boolean;

  enableShadowInpainting: boolean;

  mainDoorTypeFilter?: Array<DoorType>
  supportedProductTypes?: Array<string>
  defaultDoorType: DoorType;
  supportedDoorTypes: Array<DoorType>
  colors: CustomerColors

  hideShareButton?: boolean
  hideDownloadButton?: boolean
  hideFlipButton?: boolean
  hideRefineButtonUnderImage?: boolean
  showVisitHomepageButton?: boolean
  alwaysShowImageButtons?: boolean
  enableVisualDoorsSearch?: boolean
  showCustomAttributesFilter?: boolean
  logoPlacement: LogoPlacement
  imageButtonsArrangement: ImageButtonsArrangement
  imageButtonsPlacement: ImageButtonsPlacement
}
